<template>
    <div class="">
        <el-input placeholder="请输入姓名" icon="search" v-model="search_text">
        </el-input>

        <div class="chooselist">
            <span v-for="(item,index) in user_list" :key="item.id">{{ item.real_name }}<i class="el-icon-circle-cross" @click="removeUser(index)"></i></span>
        </div>

        <div class="list">
            <div class="top">
                <div>工号</div>
                <div>姓名</div>
                <div>岗位属性</div>
                <div>入职时间</div>
            </div>
            <z-scrollDiv class="list-wrap">
                <div class="item" v-for="item in user_options" :key="item.id" @click="chooseUser(item)">
                    <div>{{ item.user_name }}</div>
                    <div class="overhide" :title="item.real_name">{{ item.real_name }}</div>
                    <div class="overhide" :title="item.position_name">{{ item.position_name | placeholder }}</div>
                    <div>{{ item.work_date | justDate }}</div>
                </div>
            </z-scrollDiv>
        </div>
    </div>
</template>

<script>
    export default {

        props:['leaderId',"list","cancel"],
        data(){
            return {
                search_text:"",  //搜索文本
                user_list:[],  //选中的成员列表
            }
        },
        computed:{
            user_options(){  //可选成员
                return this.list?this.list.filter(item=>{
                    let user_ids = this.user_ids;
                    let leader_id = this.leaderId;
                    return item.id != leader_id && user_ids.every(id=>id!=item.id);
                }).filter(item=>{
                    return item.real_name.indexOf(this.search_text)!= -1;
                }):[];
            },
            user_ids(){  //成员id合集
                return this.user_list.map(item=>item.id);
            },
        },
        watch:{
            leaderId(id){
                let index = this.user_ids.indexOf(id);
                if(index!=-1){
                    this.user_list.splice(index,1);
                }
            },
            cancel(flag){
                if(flag){
                    this.search_text = "";
                    this.user_list = [];
                    this.$emit('cancel');
                }
            },
        },
        methods:{
            chooseUser(item){  //增加成员
                this.user_list.push(item);
                this.$emit("change",[...this.user_ids]);
            },
            removeUser(index){  // 移除成员
                this.user_list.splice(index,1);
                this.$emit("change",[...this.user_ids]);
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    // ***user列表
    .list{
        border:1px solid @border-c;
        box-sizing:border-box;
        height:300px;
        margin-top: 10px;
        border-radius: 4px;

        .top,.list-wrap .item{
            padding:0 20px;
            box-sizing: border-box;
            overflow:hidden;
            height: 28px;
            line-height: 28px;
            >div{
                float:left;
                font-size:12px;
            }
        }

        .top{
            background:#f8fafd;
            border-bottom:1px solid #d9dfe7;
            color:#aaa;
        }

        .list-wrap{
            height:calc(~"100% - 28px - 1px");
            .item{
                transition:0.3s;
                cursor: pointer;
                &:hover{
                    background:#f1f6fd;
                }
            }
        } 
            

    }

    // ***选中user
    .chooselist{
        line-height: 30px;
        min-height:30px;
        box-sizing: border-box;
        padding:0 10px;
        margin-top: 10px;
        border-radius: 4px;
        border: 1px solid @border-c;
        transition: 0.3s;
        &:hover{
            border-color: @hover-c;
        }
        &:focus{
            border-color: @focus-c;
        }

        >span{
            display: inline-block;
            margin-right: 10px;
            i{
                margin-left: 3px;
                color:@red;
                cursor: pointer;
            }
        }
    }

    .top,.list-wrap .item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 22%;
            padding-right: 3%;
        }
        >div:nth-of-type(3){
            width: 32%;
            padding-right: 3%;
        }
        >div:last-of-type{
            width: 20%;
        }
    }
</style>





// WEBPACK FOOTER //
// add-member.vue?15724a10